// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from './NoDataCell';
import IntegerValue from '../common/IntegerValue';
import { InfoTooltip } from '../tooltips';
import ComparisonItem from '@/types/comparison-item';
import DisclaimerInfos from '@/types/disclaimer-infos';
import Locale from '@/types/locale';
import NoDataText from '@/types/no-data-text';

type Props = {
  decimalPlace?: number;
  className?: string;
  disclaimer?: string;
  locale?: Locale;
  hasDisclaimer?: boolean;
  id?: string;
  item?: ComparisonItem;
  onClick?: () => void;
  valueDisclaimer?: DisclaimerInfos;
  value?: number | null;
  noDataText?: NoDataText;
};

const PercentageCell: React.FunctionComponent<Props> = ({
  className,
  disclaimer,
  decimalPlace = 2,
  hasDisclaimer,
  item,
  id,
  locale,
  onClick,
  value,
  valueDisclaimer,
  noDataText,
}: Props) => {
  if (value == null) {
    return <NoDataCell disclaimerKey={disclaimer} locale={locale} item={item} onClick={onClick} id={id} noDataText={noDataText} />;
  }

  const classes = classNames(className, 'cell percentage-cell', { 'zero-value': value === 0 });
  return (
    <div className={classes} onClick={onClick} id={id ? `cell-${id}` : undefined}>
      <span className="markup-container">
        <IntegerValue decimalPlace={decimalPlace} value={value} isPercentage locale={locale} />

        {hasDisclaimer && '*'}

        {valueDisclaimer && <InfoTooltip title={valueDisclaimer.title} message={valueDisclaimer.message} list={valueDisclaimer.list} />}
      </span>
    </div>
  );
};

export default PercentageCell;
